import gql from "graphql-tag";

export const certifiedSubscriptionFragment = gql`fragment updateplantstatustype on UpdatePlantStatusType {
  operationType
  changesPath
  email
  plant {
    devices {
      type
      sn
      installationTime
      disinstallationTime
    }
    users {
      userLevel
      email
    }
    config {
      meterInversion
      contractualPower
      phase
      monitoringType
    }
    geo {
      IANA
      latitude
      longitude
    }
    plantId
    loggers {
      info {
        def {
          thingDef
          type
          timestamp
        }
        hwv {
          hwVer
          timestamp
        }
        fw {
          cfgFileName
          cfgFileVer
          firmwareVer
          hardwareVer
          manufacturer
          model
          sn
        }
        name {
          name
          timestamp
        }
        connection {
          disconnectReason
          ipAddress
          status
          timestamp
        }
      }
      devices {
        sn
        lastUpdate
        dsps
        dspm
        created
        arm
        fota_status
      }
      inverter {
        sn
        arm
        dspm
        dsps
        fota_module
        fota_status
        updating
        lastUpdate
        upd_global {
          status
          progress
          createdAt
        }
      }
      loggerId
      lan {
        lte_IMEI
        lte_IMSI
        lte_apnServer
        lte_apnUser
        lte_apnPsw
        lte_ICCID
        lte_strength
        wifi_SSID
        wifi_ip
        wifi_routerIP
        wifi_DNS
        wifi_status
        wifi_enabled
        wifi_online
        wifi_psw
        eth_ip
        eth_routerIP
        eth_DNS
        eth_status
        eth_enabled
        eth_online
      }
    }
    plantPref {
      plantName
      monitorPref
      tagsDevices {
        key
        value
      }
    }
    ems {
      sn
    }
    ems_state {
        devices {
          type
          model
          cmd
          dModel
          sn
          active
          timestamp
          id
          id_list
          modbus_address
          d2evc
          threeF
          version
          thingDef
          sensor_mode
          registered
          rgistered
          k
          dsps
          dspm
          arm
          fw_rev
          grid_meter
        }
        info {
          connection {
            disconnectReason
            ipAddress
            status
            timestamp
          }
        }
        loggerId
        config {
          timestamp
          ta_sign
          sensor_mode
          plantCurrSensTR
          plantCurrSensO
          pext
          pType
          net
          mt_sign
          maxLoadPwr
          latitude
          longitude
          io_ing_used
          io_out_used
          invCurrSensTR
          io_cnt_func
          ext_device
          error_ts
          invCurrSensO
          error_id
          connection
          configVerified
          TZ
        }
      }
      ems_state_v2 {
      ... on ConnextDataType {
        loggerId
        config {
          TZ
          configVerified
          connection
          error_id
          ext_device
          error_ts
          invCurrSensO
          invCurrSensTR
          io_cnt_func
          io_ing_used
          io_out_used
          latitude
          longitude
          maxLoadPwr
          mt_active
          mt_pb
          mt_sign
          net
          pType
          num_device
          pext
          plantCurrSensO
          plantCurrSensTR
          sensor_mode
          ta_sign
          tap_en
          tap_pb
          tas_en
          tas_pb
          timestamp
          virtualRTStatus {
            active
            startTS
            duration
            target
          }
        }
        devices {
          active
          arm
          cmd
          d2evc
          dModel
          dspm
          dsps
          fw_rev
          grid_meter
          id_list
          id
          k
          modbus_address
          model
          registered
          rgistered
          sensor_mode
          sn
          thingDef
          threeF
          timestamp
          type
          version
        }
        evch {
          active
          carConsumption
          chargerMode
          createdAt
          error_id
          dModel
          error_ts
          fwVer
          inputGreenPower
          limitPower
          maxpw
          model
          ready
          rsn
          rt_exp
          sn
          st_cmd
          wb_err_ts
          wb_err_id
          updatedAt
          type
          tpPower
          tpDuration
          timestamp
          tStart
          status
          startTime
        }
        info {
          cell_info {
            cell_model
            cell_revision
            cell_serial
            icc_id
            updatedAt
            imei
          }
          connection {
            disconnectReason
            ipAddress
            status
            timestamp
          }
          def {
            timestamp
            type
            thingDef
          }
          fw {
            updatedAt
            type
            timestamp
            fw_ver
            fwCategory
            fota_status
            createdAt
          }
          hwv {
            hwVer
            timestamp
          }
          name {
            timestamp
            name
          }
          sn {
            updatedAt
            uid
            type
            timestamp
            sn
            createdAt
          }
        }
        io {
          active
          d_start
          d_stop
          description
          function
          index
          level
          n_out
          name
          out_state
          out1
          state
          src
          t0_start
          t0_stop
          t1_start
          t1_stop
          t2_start
          t2_stop
          t3_start
          t3_stop
          t4_start
          t4_stop
          t5_start
          t5_stop
          t6_start
          t6_stop
          t_min
          templateId
          thH1
          thH
          thL
          thL1
          time_th
          time_th1
          var1
          time_tl1
          time_tl
        }
      }
      ... on AzzurroHubDataType {
        loggerId
        config {
          IANA
          actPwrCtrlAlgo
          operational
          scanDevices
          plantPhases
          monitoringMode
          plantDetectType
          maxPlantInvPwr
          evchStrategy
          maxContractualPwr
          evchTimeStop
          intSensorInversion
          evchTimeStart
          evchTimeModeEna
          evchPwrImportValue
          evchPwrImportLimit
          evchParallelEna
          evchCtrlEna
          evchBatterySOCLimit
          evchBatteryProtectEna

          country
          actPwrCtrlTarget
          actPwrCtrlEna
          virtualRTStatus {
            active
            startTS
            duration
            target
          }
        }
        info {
          upd {
            result

          }
          fw {
            shadowVer
            scriptVer
            hwVer
            dateProd
            currVer
            currBootSlot

            bootSts
            bootErr
          }
          connection {

            status
            ipAddress
            disconnectReason
          }
        }
        pwrMagic {
          updatedAt
          sn
          removed
          ipAddr
          deviceType
          createdAt
          connected
        }

        PSC100 {
          PBUSCCO1
          PBUSCCO2
          app
          connected
          core
          createdAt
          deviceType
          gcp
          inverters {
            sn
          }
          removed
          sdk
          sn
          updatedAt
        }

        meter {
          sn
          removed
          model
          modbusAdr
          deviceType

          connected
        }
        lan {
          wifi_strength
          wifi_status
          wifi_routerIP
          wifi_online
          wifi_ip
          wifi_enabled
          wifi_SSID
          wifi_DNS1
          wifi_DNS2
          wifi_DHCP
          eth_status
          eth_routerIP
          eth_online
          eth_ip
          eth_enabled
          eth_DNS2
          eth_DNS1
          eth_DHCP

        }
        inverter {
          sn
          safetyVer
          removed
          region
          modbusAdr
          hwVer
          dspm
          dsps
          deviceType
          country
          connected
          arm
          updating
          upd_arm { status progress }
          upd_dspm { status progress }
          upd_dsps { status progress }
          upd_safety { status progress }
          upd_sofar { status progress }
        }
        evChargerCAN {
          type

          swVer
          sts
          sn
          removed
          deviceType

          connected
          alerts
        }
        evCharger485 {
          swVer
          sts
          sn
          removed
          modbusAdr
          deviceType
          connected
          alerts
        }
        heatPump {
          DHWOn
          DHWSetTemp
          climOnA
          climOpMode
          climSetTempCoolingA
          updatedAt
          sn
          removed
          modbusAdr
          globStatus
          deviceType
          createdAt
          connected
          climSetTempHeatingA
        }
        solarSensor {
          deviceType
          sn
          connected
          removed
          updatedAt
          createdAt
        }
      }
    }
  }
} `;
